import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService
} from '@azure/msal-angular';
import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { ResearchComponentsCoreModule } from '@corteva-research/ngx-components-core';
import { ResearchComponentsMsalIntegrationModule } from '@corteva-research/ngx-components-msal-integration';
import { FilterService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { settings } from '../settings/environment';
import CustomPreset from '../utils/custom-preset';
import { routes } from './app.routes';
import { SETTINGS } from './app.settings';
import { AppInitService } from './services/app-init.service';
import { GlobalErrorHandlerService } from './services/error-handler.service';
import { LoaderService } from './services/loader.service';
import { MSGraphService } from './services/msgraph.service';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function initializeApp(appInitService: AppInitService) {
  return () => appInitService.initApp();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: CustomPreset,
        options: {
          darkModeSelector: 'none'
        }
      }
    }),
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    LoaderService,
    MessageService,
    importProvidersFrom(ToastModule),
    FilterService,
    MSGraphService,
    {
      provide: SETTINGS,
      useValue: settings
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(ResearchComponentsCoreModule.forRoot('Target Selection'), ResearchComponentsMsalIntegrationModule, BrowserAnimationsModule),
    {
      provide: ResearchComponentsCoreModule,
      useValue: undefined
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: () => new PublicClientApplication(settings.msal.config)
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: () => settings.msal.guard
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: () => settings.msal.interceptor
    }
  ]
};
